/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Muokkaa",
  "i18n.actionBar.removeImage": "Poista",
  "i18n.actionBar.swapImage": "Vaihda",
  "i18n.additionalInfoItemLayers.smartSorted.new": "Uutta!",
  "i18n.additionalProducts.addToCart": "Lisää tilaukseen",
  "i18n.additionalProducts.frame.description": "Laadukas alumiinikehys: mattahopea, aito premium-lasi, ei liimaa tarvita",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Vinkki:",
  "i18n.additionalProducts.frame.subtitle": "Valmis palapeli on upea muisto – ja <b>kehyksiin</b> asetettuna tuot sen tyylikkäästi esille.",
  "i18n.additionalProducts.frame2023.description": "Laadukkaat puukuitukehykset – helppo asentaa, ilman lasia, sis. palapeliliiman",
  "i18n.additionalProducts.framePlastic.description": "Laadukas alumiinikehys: mattahopea, heijastamaton pleksilasi, ei liimaa tarvita",
  "i18n.additionalProducts.glue.description": "Enintään kahdelle 1000 palan palapelille, sis. levityssienen",
  "i18n.additionalProducts.glue.hook": "Näin palapelistäsi tulee taulu.\nLiimaa ja suojaa pysyvästi.",
  "i18n.additionalProducts.roll.description": "48–2000 palan palapeleille",
  "i18n.additionalProducts.roll.hook": "Ei vapaata pöytää? Ei hätää.\nRullaa palapeli, laita talteen ja jatka myöhemmin.",
  "i18n.adventCalendarOverlay.activate": "Näytä 24 luukun esikatselu",
  "i18n.adventCalendarOverlay.deactivate": "Piilota 24 luukun esikatselu",
  "i18n.adventCalendarOverlay.notice": "(numeroita ja viivoja ei paineta)",
  "i18n.button.addToCart": "Lisää ostoskoriin",
  "i18n.button.apply": "Käytä",
  "i18n.button.back": "Takaisin",
  "i18n.button.cancel": "Peruuta",
  "i18n.button.cancelAndFix": "Muuta nyt",
  "i18n.button.chooseSmartSorted": "Valitse SMART SORTED ",
  "i18n.button.close": "Sulje",
  "i18n.button.continue": "Jatka",
  "i18n.button.createNewTextPlaceholders": "Syötä teksti ",
  "i18n.button.ignore": "Ohita",
  "i18n.button.ignoreAndContinue": "Jatka silti",
  "i18n.button.mobile.createNewTextPlaceholders": "Teksti",
  "i18n.button.noChanges": "Ei kiitos, sulje ikkuna",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Valokuvat",
  "i18n.button.retry": "Yritä uudelleen",
  "i18n.button.uploadPhotos": "Lataa valokuva(t)",
  "i18n.button.withSmartSorted": "Valitse SMART SORTED ",
  "i18n.button.withoutSmartSorted": "Ei kiitos, sulje ikkuna",
  "i18n.control.colorChooser.color": "Väri",
  "i18n.control.fontChooser.placeholderText": "Fontti",
  "i18n.control.imageQuality.checkImages": "Tarkasta resoluutio",
  "i18n.control.imageQuality.imageSuitability": "Valokuvan laatu:",
  "i18n.control.imageQuality.indicatorAltText": "Valokuvan laatu",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Valitse layout",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Paranna luettavuutta lyhentämällä tekstiä / riviä.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Valittu fontti on liian suuri tälle tekstille.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Tälle tekstille ei voi valita suurempaa fonttikokoa.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Tälle tekstille ei voi valita pienempää fonttikokoa.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Lisää rivinvaihto",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Jatka kirjoittamista toisella rivillä tai suurenna tekstikenttää.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Tarkista teksti, kaikki fontit eivät tue tätä fonttia.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Enimmäismäärä merkkejä on saavutettu",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Paranna luettavuutta lyhentämällä tekstiä / riviä.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Suurenna tekstikenttää",
  "i18n.dialog.deletePlaceholder.message": "Tätä toimintoa ei voi peruuttaa",
  "i18n.dialog.deletePlaceholder.title": "Haluatko varmasti poistaa paikkamerkin?",
  "i18n.dialog.error.title": [
    "On tapahtunut virhe",
    "On tapahtunut virheitä"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Tämän kuvan resoluutio on liian alhainen, joten painetun kuvan laatu ei ole optimaalinen!",
  "i18n.dialog.smartSorted.message": "Innovatiivinen SMART SORTED helpottaa 1 000 palan palapelin kokoamista jopa ilman mallikuvaa.",
  "i18n.dialog.smartSorted.title": "Onnistumisen hetket taattu",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klikkaamalla  \"{{text}}\" voit muuttaa laatikon otsikkoa.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Laatikon otsikkoa ei ole muutettu",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Jatka ilman laatikon otsikkoa",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Jotain puuttuu vielä! Lisää valokuva",
    "Jotain puuttuu vielä! Lisää kuvia"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Yksi paikkamerkki on vielä tyhjä",
    "Jotkut paikkamerkit ovat vielä tyhjiä"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Paikkamerkkiä ei ole muutettu",
    "Paikkamerkkejä ei ole muutettu."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Klikkaamalla valokuvan tai tekstin paikkamerkkiä voit muuttaa kollaasia",
    "Klikkaamalla valokuvan ja tekstin paikkamerkkejä voit muuttaa kollaasia"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Paikkamerkkiä ei ole muutettu",
    "Joitakin paikkamerkkejä ei ole muutettu"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Klikkaamalla tekstin paikkamerkkiä voit muuttaa tekstiä",
    "Klikkaamalla tekstin paikkamerkkejä voit muuttaa tekstejä"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Tekstin paikkamerkkiä ei ole muutettu",
    "Joitakin tekstin paikkamerkkejä ei ole muutettu"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "muuttamattomat paikkamerkit",
  "i18n.error.additionalInfoItemsError.message": "latausvirheen tietokerros",
  "i18n.error.additionalInfoItemsError.title": "Virhe latautui",
  "i18n.error.deprecatedBrowserError.message": "Käyttämääsi selainta ei enää tueta. Päivitä selaimesi uudempaan versioon.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Suunnitteluprosessi keskeytetty",
  "i18n.error.designerExpiredError.title": "Keskeytit suunnittelun pidemmäksi aikaa, eikä suunnittelua voi jatkaa.\nAloita suunnittelu uudelleen.",
  "i18n.error.fontLoadingError.message": "Fonttia ei voitu ladata",
  "i18n.error.fontLoadingError.title": "Virhe latautui",
  "i18n.error.imageLoadingError.message": "Valokuvaa ei voitu ladata.  Se on poistettu suunnittelualueelta ja valikoimasta.",
  "i18n.error.imageLoadingError.title": "Virhe palvelimelta ladattaessa",
  "i18n.error.imageProvisionError.message": "Yhtä tai useampaa valokuvaa ei voitu käsitellä. Todennäköisesti mediatyyppiä ei tueta",
  "i18n.error.imageProvisionError.title": "Valokuvaa ei voitu käsitellä",
  "i18n.error.imageSelectionError.message": "Tiedostoa \"{{reference1}}\" ei voitu käsitellä.",
  "i18n.error.imageSelectionError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.imageSizeLimitExceededError.message": "Lataamasi kuva on liian suuri.\nPienennä kuvaa niin, että kuva on korkeintaan 180 megapikseliä, ja lataa kuva uudelleen.",
  "i18n.error.imageSizeLimitExceededError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.imageUploadError.message": "Internetyhteydessä on tapahtunut virhe.\nYritä myöhemmin uudelleen.",
  "i18n.error.imageUploadError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.inlineSVGLoadingError.message": "Toleranssikehystä \"{{reference1}}\" ei voitu ladata.",
  "i18n.error.inlineSVGLoadingError.title": "Virhe palvelimelta ladattaessa",
  "i18n.error.invalidCharConfigError.message": "Tämä fontti ei ole käytettävissä, valitse toinen fontti.",
  "i18n.error.invalidCharConfigError.title": "Fontti ei ole käytettävissä",
  "i18n.error.malformedProductError.message": "Yhden tai useamman tuotteen siirto palvelimelle epäonnistui. Tuotetta ei mahdollisesti ole enää saatavilla tai tuotteen suunnittelu kesti liian kauan.\n\nPahoittelemme tilannetta. Aloita suunnittelu uudelleen.",
  "i18n.error.malformedProductError.title": "Tuotevirhe ",
  "i18n.error.notInStockError.message": "Valitsemasi tuote ei ole tällä hetkellä valitettavasti saatavilla.\nKlikkaamalla vasemmassa yläreunassa olevaa puzzleYOU-logoa pääset takaisin aloitussivulle, josta voit valita jonkin toisen tuotteen.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Internetyhteytesi on ilmeisesti katkennut. Voit jatkaa tuotteesi suunnittelua heti kun yhteys taas toimii.",
  "i18n.error.templateLoadingError.message": "Mallipohjaa \"{{ error.reference[0] }}\" ei voitu ladata.\nYritä myöhemmin uudelleen.",
  "i18n.error.templateLoadingError.title": "Virhe palvelimelta ladattaessa",
  "i18n.error.transformationError.message": "Muunnosta ei voitu suorittaa ",
  "i18n.error.transformationError.title": "Muunnosvirhe",
  "i18n.error.traudlLoadingError.message": "Yritä uudelleen tai käytä jotain toista kuvaa.",
  "i18n.error.traudlLoadingError.title": "Tekoälytoimintoa ei voitu käyttää.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" mediatyyppiä ei tueta.",
  "i18n.error.unsupportedMediaTypeError.title": "Virhe ladattaessa valokuvaa palvelimelle",
  "i18n.error.uploadProductError.message": "Yhtä tai useampaa tuotetta ei voitu siirtää palvelimelle.\nYritä myöhemmin uudelleen.",
  "i18n.error.uploadProductError.title": "Virhe tiedonsiirrossa",
  "i18n.error.zoomModeError.message": "Edellisen layoutisi tekstiä ei voitu käyttää. Syötä uusi teksti.",
  "i18n.error.zoomModeError.title": "Tekstiä ei voitu käyttää",
  "i18n.gallery.uploadPhotos.info": "Klikkaa painiketta \"Lataa valokuva(t)\"",
  "i18n.gallery.uploadProgress": [
    "Ladataan valokuvaa…",
    "Ladatut valokuvat: {{current}} > {{total}}"
  ],
  "i18n.price.price": "Hinta",
  "i18n.price.reduction": "Säästät ",
  "i18n.price.total": "Kokonaishinta",
  "i18n.priceDisplay.times": [
    "{{value}} kappale hintaan {{pricePerUnit}}",
    "{{value}} kappaletta hintaan {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Tarvikkeet (valinnainen)",
  "i18n.progressOverlay.message.lines.one": "Kiitos huolella suunnittelemastasi tuotteesta.",
  "i18n.progressOverlay.message.lines.two": "Valmistelemme juuri tilauksesi seuraavaa vaihetta…",
  "i18n.template.insertText": "Syötä teksti tähän",
  "i18n.toolbox.gallery.title": "Valitse valokuvat",
  "i18n.toolbox.image.title": "Muokkaa valokuvaa",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 valokuva",
    "{{value}} valokuvaa"
  ],
  "i18n.toolbox.layout.title": "Valitse ulkoasu",
  "i18n.toolbox.layout.triggerText": "Layout",
  "i18n.toolbox.preview.title": "3D-esikatselu",
  "i18n.toolbox.productChooser.title": "Vaihda tuote",
  "i18n.toolbox.productChooser.triggerText": "Tuote",
  "i18n.toolbox.text.title": "Muokkaa tekstiä"
};


export class LocaleFiFI {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
